import React, { useEffect, useState } from 'react'
import LeftBar from '../Components/LeftBar'
import BottomNav from '../Components/BottomNav'
import Topbar from '../Components/Topbar'
import { useParams, useNavigate } from 'react-router-dom'
import { Modal, Button, Form } from 'react-bootstrap';
import {
    getFirestore,
    doc,
    getDoc,
    collection,
    query,
    where,
    getDocs,
    updateDoc,
    arrayUnion
} from 'firebase/firestore'
import { app } from '../firebase'
import Spinner from 'react-bootstrap/Spinner'
import defaultProfile from '../Images/def.png'
import { saveAs } from "file-saver"
import swal from 'sweetalert';
import { getAuth } from "firebase/auth";

function ViewAd() {
    const { adId } = useParams()
    const navigate = useNavigate()
    const db = getFirestore(app)

    const [loading, setLoading] = useState(true)
    const [adData, setAdData] = useState(null)
    const [advertiser, setAdvertiser] = useState(null)
    const [incomeData, setIncomeData] = useState(null)
    const [influencerData, setInfluencer] = useState();

      useEffect(() => {
        document.title = "Zindua App | Dashboard";
    
        // Meta description
        let desc = document.querySelector("meta[name='description']");
        if (!desc) {
          desc = document.createElement("meta");
          desc.setAttribute("name", "description");
          document.head.appendChild(desc);
        }
        desc.setAttribute("content", "Zindua App dashboard");
    
        // Open Graph tags
        const ogTags = [
          { property: "og:title", content: "Zindua App | Dashboard" },
          { property: "og:description", content: "Zindua App Dashboard" },
          { property: "og:type", content: "website" },
          { property: "og:url", content: "https://zindua.app/dashboard" },
          { property: "og:image", content: "https://zindua.app/logo192.png" },
        ];
    
        ogTags.forEach(({ property, content }) => {
          let tag = document.querySelector(`meta[property='${property}']`);
          if (!tag) {
            tag = document.createElement("meta");
            tag.setAttribute("property", property);
            document.head.appendChild(tag);
          }
          tag.setAttribute("content", content);
        });
    
        // JSON-LD structured data
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.text = JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Zindua App Influencer Dashboard",
          "url": "https://zindua.app/dashboard",
          "description": "Zindua App influencer dashboard where you can manage your earnings, running ads, subscriptions, and withdraw funds to M-Pesa.",
          "inLanguage": "en",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://zindua.app/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Dashboard",
                "item": "https://zindua.app/dashboard"
              }
            ]
          }
        });
        document.head.appendChild(script);
    
        return () => {
          document.head.removeChild(script);
        };
      }, []);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)

            try {
                const adRef = doc(db, 'ads', adId)
                const adSnap = await getDoc(adRef)

                if (!adSnap.exists()) {
                    setLoading(false)
                    return
                }

                const ad = adSnap.data()
                setAdData(ad)

                if (ad.loggedInUserId) {
                    const userRef = doc(db, 'users', ad.loggedInUserId)
                    const userSnap = await getDoc(userRef)
                    if (userSnap.exists()) {
                        setAdvertiser(userSnap.data())
                    }
                }


                if (ad.influencerId) {
                    const userRef = doc(db, 'users', ad.influencerId)
                    const userSnap = await getDoc(userRef)
                    if (userSnap.exists()) {
                        setInfluencer(userSnap.data())
                    }
                }

                const incomeRef = collection(db, 'income')
                const q = query(incomeRef, where('adID', '==', adId))
                const incomeSnap = await getDocs(q)

                if (!incomeSnap.empty) {
                    setIncomeData(incomeSnap.docs[0].data())
                }

            } catch (error) {
                console.error(error)
            }

            setLoading(false)
        }

        fetchData()
    }, [adId, db])

    const capitalize = value => {
        if (!value || typeof value !== 'string') return ''
        return value.charAt(0).toUpperCase() + value.slice(1)
    }

    const formatAdType = type => {
        if (!type) return ''
        if (type === 'cgc') return 'Creator Generated Content'
        if (type === 'post') return 'Post'
        if (type === 'story') return 'Story'
        return capitalize(type)
    }

    // Convert your public URL to bucket path
    const getBucketPath = url => {
        const pathMatch = url.match(/o\/(.+)\?/)
        if (!pathMatch) return null
        return decodeURIComponent(pathMatch[1])
    }

    const handleDownload = url => {
        const path = getBucketPath(url)
        if (!path) return console.error("Invalid URL")

        const downloadEndpoint = `https://us-central1-zindua-ke.cloudfunctions.net/downloadFile/download?path=${encodeURIComponent(path)}`
        window.open(downloadEndpoint, "_blank")
    }


    const handleViewMedia = () => {
        navigate(`/view-media/${adId}`, {
            state: {
                files: adData.uploadedFiles,
                type: adData.uploadType
            }
        })
    }


    const notifyAdvertiser = async (phone, email, subject, message) => {
        try {
            const auth = getAuth();
            const user = auth.currentUser;

            if (!user) {
                console.error("User not authenticated");
                return;
            }

            // Get Firebase ID token
            const token = await user.getIdToken();

            const headers = {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            };

            // Send SMS
            if (phone) {
                await fetch("https://us-central1-zindua-ke.cloudfunctions.net/commapi/send-sms", {
                    method: "POST",
                    headers,
                    body: JSON.stringify({ phoneNumber: phone, message })
                });
            }

            // Send Email
            if (email) {
                await fetch("https://us-central1-zindua-ke.cloudfunctions.net/commapi/send-email", {
                    method: "POST",
                    headers,
                    body: JSON.stringify({ email, subject, message })
                });
            }

        } catch (err) {
            console.error("Failed to send notification:", err);
        }
    };


    // Function to handle the approval
    const handleApprove = async () => {
        // Show SweetAlert confirmation
        swal({
            title: "Are you sure?",
            text: "Once approved, the ad status will be set to Running and the advertiser will be notified.",
            icon: "warning",
            buttons: ["Cancel", "Approve"],
            dangerMode: true,
        })
            .then(async (willApprove) => {
                if (willApprove) {
                    // Update the adStatus to "Running" in Firestore
                    try {
                        const adRef = doc(db, 'ads', adId)
                        await updateDoc(adRef, {
                            adStatus: "Running"
                        })
                        swal("Success!", "The ad status has been updated to Running.", "success");
                        // Optionally, reload data or navigate away after success
                        setAdData(prev => ({ ...prev, adStatus: "Running" }));
                        // Notify advertiser
                        if (advertiser) {
                            const message = `Your ad "${adData.brandName}" has been approved by ${influencerData.userName} and is now running.`;
                            await notifyAdvertiser(advertiser.mpesaNumber, advertiser.email, "AD APPROVED", message);
                        }
                    } catch (error) {
                        console.error("Error updating ad status:", error);
                        swal("Error!", "Something went wrong. Please try again later.", "error");
                    }
                }
            });
    }

    const [showRejectModal, setShowRejectModal] = useState(false);
    const [rejectReason, setRejectReason] = useState('');

    const handleOpenRejectModal = () => setShowRejectModal(true);
    const handleCloseRejectModal = () => setShowRejectModal(false);

    const handleRejectConfirm = async () => {
        if (!rejectReason) return alert("Please select a reason");

        try {
            const adRef = doc(db, 'ads', adId);
            await updateDoc(adRef, {
                adStatus: "Rejected",
                rejectionReason: rejectReason
            });
            setAdData(prev => ({ ...prev, adStatus: "Rejected" }));
            handleCloseRejectModal();

            // Notify advertiser
            if (advertiser) {
                const message = `Your ad "${adData.brandName}" has been rejected by ${influencerData.userName}. Reason: ${rejectReason}.`;
                await notifyAdvertiser(advertiser.mpesaNumber, advertiser.email, "AD REJECTED", message);
            }
        } catch (error) {
            console.error(error);
            alert("Failed to update ad status");
        }
    }

    const [showReportModal, setShowReportModal] = useState(false);
    const [reportLink, setReportLink] = useState('');
    const [reportDesc, setReportDesc] = useState('');
    const handleOpenReportModal = () => setShowReportModal(true);
    const handleCloseReportModal = () => setShowReportModal(false);

    const handleSubmitReport = async () => {
        if (!reportLink || !reportDesc) {
            alert("Please fill in both fields");
            return;
        }

        try {
            const adRef = doc(db, 'ads', adId);

            // Save report in a new field `reports` as an array of objects
            await updateDoc(adRef, {
                adStatus: "Approval",
                reports: arrayUnion({
                    link: reportLink,
                    description: reportDesc,
                    submittedAt: new Date()
                })
            });
            setAdData(prev => ({ ...prev, adStatus: "Approval" }));
            handleCloseReportModal();
            setReportLink('');
            setReportDesc('');
            alert("Report submitted successfully");
        } catch (error) {
            console.error("Error submitting report:", error);
            alert("Failed to submit report");
        }
    }

    if (loading) {
        return (
            <div className="mainDashboard">
                <div className="desktopOnly">
                    <LeftBar />
                </div>
                <div className="mainContent">
                    <Topbar />
                    <div style={{ padding: '20px', textAlign: 'center' }}>
                        <Spinner animation="border" />
                    </div>
                </div>
                <div className="mobileOnly">
                    <BottomNav />
                </div>
            </div>
        )
    }

    if (!adData) {
        return (
            <div className="mainDashboard">
                <div className="desktopOnly">
                    <LeftBar />
                </div>
                <div className="mainContent">
                    <Topbar />
                    <div style={{ padding: '20px', textAlign: 'center' }}>
                        <p>Ad not found</p>
                    </div>
                </div>
                <div className="mobileOnly">
                    <BottomNav />
                </div>
            </div>
        )
    }



    return (
        <div className="mainDashboard">
            <div className="desktopOnly">
                <LeftBar />
            </div>

            <div className="mainContent">
                <Topbar />

                <section className="adDetailPage container mt-3">
                    <div className="adDetailPageTop">
                        <h5>
                            {adData.brandName}{' '}
                            <span className="adDetailSpan">
                                {adData.adStatus}
                            </span>
                        </h5>
                        <div>
                            {adData.adStatus === "Submitted" && (
                                <>
                                    <button className="approveAd" onClick={handleApprove}>Approve</button>
                                    <button className="rejectAd" onClick={handleOpenRejectModal}>Reject</button>
                                </>
                            )}

                            {adData.adStatus === "Running" && (
                                <button className="approveAd" onClick={handleOpenReportModal}>Complete ad and submit a report</button>
                            )}

                            {adData.adStatus === "NeedsCorrection" && (
                                <button className="approveAd" onClick={handleOpenReportModal}>Resubmit Report</button>
                            )}
                        </div>

                    </div>

                    <div className="adDetailPageTopTwo">
                        <p>
                            <strong>Social Platform:</strong>{' '}
                            {capitalize(adData.social)}{' '}
                            {formatAdType(adData.adType)}
                        </p>

                        <p>
                            <strong>Ad Amount:</strong>{' '}
                            {incomeData
                                ? `KES ${Number(incomeData.totalCost).toLocaleString()}`
                                : '-'}
                        </p>

                        <p>
                            <strong>Payout Amount:</strong>{' '}
                            {incomeData
                                ? `KES ${Number(incomeData.payout).toLocaleString()}`
                                : '-'}
                        </p>

                        <p>
                            <strong>Payout Status:</strong>{' '}
                            {incomeData?.payoutStatus || '-'}
                        </p>
                    </div>

                    <div className="adDetailPageCont">
                        <div className="adDetailPageLeft">
                            <p><strong>Business Category:</strong> {adData.businessCategory}</p>
                            <p><strong>Ad Purpose:</strong> {adData.adPurpose}</p>
                            <p>
                                <strong>Delivery Time:</strong> {adData.cgcDeliveryTime || '36 hours'}
                            </p>
                            <p><strong>What the business does:</strong> {adData.businessDesc}</p>
                            <p><strong>Website or Social Link:</strong> {adData.websiteLink}</p>

                            {adData.cgcDetails && (
                                <p>
                                    <strong>Content Guidelines:</strong><br />
                                    {adData.cgcDetails}
                                </p>
                            )}

                            {adData.uploadedFiles && adData.uploadedFiles.length > 0 && (
                                <p>
                                    <strong>Uploaded file type:</strong>{' '}
                                    {capitalize(adData.uploadType)}
                                </p>
                            )}

                            {adData.postCaption && (
                                <p>
                                    <strong>Post Caption:</strong><br />
                                    {adData.postCaption}
                                </p>
                            )}

                            <p>
                                <strong>Submitted On:</strong>{' '}
                                {adData.timestamp?.toDate().toLocaleString()}
                            </p>

                            {adData.uploadedFiles && adData.uploadedFiles.length > 0 && (
                                <div>
                                    <button onClick={handleViewMedia}>
                                        View {capitalize(adData.uploadType)}
                                    </button>

                                    <button
                                        onClick={() =>
                                            adData.uploadedFiles.forEach(file =>
                                                handleDownload(file)
                                            )
                                        }
                                    >
                                        Download {capitalize(adData.uploadType)}
                                    </button>
                                </div>
                            )}


                        </div>

                        <div className="adDetailPageRight">
                            <p>Advertiser details</p>

                            {advertiser && (
                                <>
                                    <div className="adDetailProfPic">
                                        <img
                                            src={advertiser.profileImage || defaultProfile}
                                            alt="profile"
                                        />
                                    </div>

                                    <h6>{advertiser.userName}</h6>
                                    <p>{advertiser.countryName}</p>
                                    <p>
                                        Joined:{' '}
                                        {advertiser.timestamp?.toDate().toLocaleDateString()}
                                    </p>
                                </>
                            )}
                        </div>
                    </div>

                    {adData.adStatus === "NeedsCorrection" && adData.correctionNote && (
                        <div className="correctionNote alert alert-primary mt-3">
                            <strong>Correction Note:</strong>
                            <p>{adData.correctionNote}</p>
                            <small>Sent on: {adData.correctionSentAt?.toDate().toLocaleString()}</small>
                            <hr />
                        </div>
                    )}

                    {adData.reports && adData.reports.length > 0 && (
                        <div className="adDetailPageTopTwo">
                            <div>
                                <h6>Submitted Report</h6>
                                {adData.reports.map((report, index) => (
                                    <div key={index} className="reportItem">
                                        <p><strong>Post Link:</strong> <a href={report.link} target="_blank" rel="noopener noreferrer">{report.link}</a></p>
                                        <p><strong>Description:</strong> {report.description}</p>
                                        <p><strong>Submitted At:</strong> {report.submittedAt?.toDate ? report.submittedAt.toDate().toLocaleString() : new Date(report.submittedAt).toLocaleString()}</p>
                                        <hr />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {adData.adStatus === "Rejected" && adData.rejectionReason && (
                        <div className="adRejected mt-3 card" style={{ padding: '10px', border: '1px solid #f00', backgroundColor: '#ffe6e6' }}>
                            <h6>This ad was rejected because:</h6>
                            <p>{adData.rejectionReason}</p>
                        </div>
                    )}

                </section>
            </div>

            <div className="mobileOnly">
                <BottomNav />
            </div>

            <Modal show={showRejectModal} onHide={handleCloseRejectModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Reject Ad</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Select a reason for rejection</Form.Label>
                            <Form.Select
                                value={rejectReason}
                                onChange={(e) => setRejectReason(e.target.value)}
                            >
                                <option value="">Select reason</option>
                                <option value="Content not relevant">Content not relevant</option>
                                <option value="Brand values do not align">Brand values do not align</option>
                                <option value="Poor creative quality">Poor creative quality</option>
                            </Form.Select>
                            <br />
                            <p>The advertiser will be refunded in full</p>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseRejectModal}>Cancel</Button>
                    <Button variant="danger" onClick={handleRejectConfirm}>Reject Ad</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showReportModal} onHide={handleCloseReportModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Submit Ad Report</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Post / Story Link URL</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter post URL"
                                value={reportLink}
                                onChange={(e) => setReportLink(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Short Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder="Enter a short description"
                                value={reportDesc}
                                onChange={(e) => setReportDesc(e.target.value)}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseReportModal}>Cancel</Button>
                    <Button variant="primary" onClick={handleSubmitReport}>Submit Report</Button>
                </Modal.Footer>
            </Modal>

        </div>
    )


}

export default ViewAd